import { RTKQueryTag } from 'src/common/constants';
import type { ApiResponse } from 'src/common/interfaces';
import type { RunningInstance } from 'src/common/interfaces/instances';
import type { StartVMRequestBody } from 'src/common/interfaces/vms';
import { apiSlice } from 'src/features/api/api-slice';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    postStartVm: builder.mutation<ApiResponse<RunningInstance>, StartVMRequestBody>({
      query: ({ ...body }) => ({
        url: 'vms/start',
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error) => (!error && result ? [RTKQueryTag.RunningInstances] : []),
    }),
  }),
});

export const { usePostStartVmMutation } = extendedApiSlice;
